// assets/variant-updater.js

console.log("Variant updater script loaded");

document.addEventListener("DOMContentLoaded", function() {
  var productTitle = document.getElementById("product-title");
  var variantDescriptionAccordion = document.getElementById("variant-description-accordion");
  var variantDescriptionTab = document.getElementById("variant-description");
  var variantRadios = document.querySelectorAll('input[type="radio"][name^="option"]');
  var productForm = document.querySelector('form[action="/cart/add"]');
  
  var specTitle = document.getElementById('variant-spec-title');
  var specTables = document.querySelectorAll('.spec-table');

  var variants = JSON.parse(document.getElementById("product-variants-json").textContent);

  console.log("Loaded variants:", variants);
  console.log("Number of variant radios:", variantRadios.length);

  function initializeProductInfo() {
    if (variants.length === 1) {
      // If there's only one variant, update with that
      updateTitle(variants[0]);
      updateDescription(variants[0]);
      updateVariantSpecs(variants[0]);
    } else {
      // For products with multiple variants, use the selected option
      updateProductInfo();
    }
  }

  function updateProductInfo() {
    var selectedOptions = Array.from(variantRadios)
      .filter(radio => radio.checked)
      .map(radio => radio.value);

    console.log("Selected options:", selectedOptions);

    var variant;
    if (selectedOptions.length === 0 && variants.length === 1) {
      // If no options are selected and there's only one variant, use that
      variant = variants[0];
    } else {
      variant = findMatchingVariant(selectedOptions);
    }

    if (variant) {
      console.log("Matched variant:", variant);
      updateTitle(variant);
      updateDescription(variant);
      updateVariantSpecs(variant);
      
      // Dispatch a custom event for other scripts to listen to
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: variant } }));
    } else {
      console.log("No matching variant found");
    }
  }

  function findMatchingVariant(selectedOptions) {
    return variants.find(variant => 
      variant.options.every((option, index) => option === selectedOptions[index])
    );
  }

  function updateTitle(variant) {
    if (productTitle) {
      const baseTitle = productTitle.getAttribute("data-product-title");
      if (variants.length > 1 && variant.title !== "Default Title") {
        productTitle.textContent = `${baseTitle} - ${variant.title}`;
      } else {
        productTitle.textContent = baseTitle;
      }
      console.log("Updated title to:", productTitle.textContent);
    } else {
      console.warn("productTitle element not found");
    }
  }

  function formatDescription(description) {
    // Split the description into lines
    const lines = description.split('\n');
    let formattedDescription = '';
    let isHeader = false;

    lines.forEach((line, index) => {
      line = line.trim();
      if (line) {
        // Check if this line could be a header
        if (line.length < 50 && !line.endsWith('.') && index < lines.length - 1 && lines[index + 1].trim()) {
          // This line is short, doesn't end with a period, and is followed by content - likely a header
          formattedDescription += `<b class="product-description-header">${line}</b><br>`;
          isHeader = true;
        } else {
          // Not a header, just a regular paragraph
          if (isHeader) {
            formattedDescription += `<p>${line}</p>`;
          } else {
            formattedDescription += line + '<br>';
          }
          isHeader = false;
        }
      } else {
        // Empty line, add a line break
        formattedDescription += '<br>';
      }
    });

    return formattedDescription;
  }

  function updateDescription(variant) {
    var descriptionElement = document.getElementById(`variant-description-${variant.id}`);
    if (descriptionElement) {
      var description = descriptionElement.getAttribute("data-description");
      // Format the description
      description = formatDescription(description);
      if (variantDescriptionAccordion) variantDescriptionAccordion.innerHTML = description;
      if (variantDescriptionTab) variantDescriptionTab.innerHTML = description;
      console.log("Updated description for variant:", variant.id);
    } else {
      console.warn(`Description element not found for variant ${variant.id}`);
    }
  }

  function updateVariantSpecs(variant) {
    console.log("Updating specs for variant:", variant);
    if (!variant) {
      console.error("Variant is undefined in updateVariantSpecs");
      return;
    }
    specTables.forEach(function(table) {
      console.log("Checking table:", table.id, "against variant:", variant.id);
      if (table.id === `spec-table-${variant.id}`) {
        table.style.display = 'table';
        if (specTitle) {
          specTitle.textContent = `Specifications for ${variant.title}`;
        } else {
          console.warn("specTitle element not found");
        }
        updateFixedRows(table, variant);
      } else {
        table.style.display = 'none';
      }
    });
  }

  function updateFixedRows(table, variant) {
    // Update SKU
    table.rows[0].cells[1].textContent = variant.sku || 'N/A';
    // Update EAN (barcode)
    table.rows[1].cells[1].textContent = variant.barcode || 'N/A';
  }

  function populateSpecTables() {
    specTables.forEach(table => {
      const variantId = table.id.split('-').pop();
      const specDataElement = document.getElementById(`spec-data-${variantId}`);
      if (specDataElement) {
        try {
          const specs = JSON.parse(specDataElement.textContent);
          const tbody = table.querySelector('tbody');
          // Start from the 3rd row (index 2) to preserve the fixed rows (SKU and EAN)
          for (let i = tbody.rows.length - 1; i >= 2; i--) {
            tbody.deleteRow(i);
          }
          specs.forEach(spec => {
            const row = tbody.insertRow();
            const cell1 = row.insertCell(0);
            const cell2 = row.insertCell(1);
            cell1.innerHTML = `<strong>${spec.name}</strong>`;
            cell1.className = 'spec-name';
            cell2.textContent = Array.isArray(spec.value) ? spec.value.join(', ') : spec.value;
            cell2.className = 'spec-value';
          });
        } catch (error) {
          console.error('Error parsing spec data:', error);
        }
      }
    });
  }

  variantRadios.forEach(radio => {
    radio.addEventListener("change", function() {
      console.log("Variant changed:", this.value);
      updateProductInfo();
    });
  });

  console.log("Running initial populateSpecTables");
  populateSpecTables(); // Populate spec tables on initial load

  console.log("Running initial initializeProductInfo");
  initializeProductInfo(); // Initial update for all products
});